import Dropzone from 'react-dropzone'
import React, { Component } from 'react';
import { Table } from 'reactstrap';
import AddDocumentFormModal from '../modals/AddDocumentFormModal'

class DropZoneTable extends Component {
  constructor(props) {
    super(props);
      this.state = {
          accept: '',
          files: [],
          dropzoneActive: false,
          popoverOpen: false,
          addmodal: false,
          selectedDocument: {},
          selectedFileName:""
        }
  
    this.documentSelected = this.documentSelected.bind(this);
    this.toggleModal = this.toggleModal.bind(this)
    this.toggle = this.toggle.bind(this)
    this.toggleAddModal = this.toggleAddModal.bind(this);
  }

  toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }

  documentSelected()
  {
    //close the popup
    this.toggle();
    //display the add new document modal.
    this.toggleAddModal();
  }

  toggleModal() {
      this.setState({
          modal: !this.state.modal,
          popoverOpen: false
      });
  }

  toggleAddModal() {
    try 
    {
      this.setState({
        addmodal: !this.state.addmodal,
        popoverOpen: false
      });  
    } 
    catch (error)
    {
      console.error(error)
    }
  }


    onDragEnter() {
      this.setState({
        dropzoneActive: true
      });
    }
  
    onDragLeave() {
      this.setState({
        dropzoneActive: false
      });
    }
  
    onDrop(files) 
    {
      this.setState(
        {
          selectedDocument: files[0],
          selectedFileName: files[0].name,
          dropzoneActive: false
        }
      );

      this.documentSelected();
      //this.setState({
      //  files,
      //  dropzoneActive: false
      //});
    }
  
    applyMimeTypes(event) {
      this.setState({
        accept: event.target.value
      });
    }
  
    render() {
      const { accept, files, dropzoneActive } = this.state;
      const overlayStyle = {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        padding: '2.5em 0',
        background: 'rgba(0,0,0,0.5)',
        textAlign: 'center',
        color: '#fff'
      };
      
      let addDocumentModalPopup = <div />

      if(this.state.addmodal)
        addDocumentModalPopup = <AddDocumentFormModal 
                                  refresh={this.props.refresh} 
                                  parentType={this.props.DocumentType} 
                                  parentRef={this.props.DocumentRef} 
                                  fileName={this.state.selectedFileName} 
                                  fileData={this.state.selectedDocument} 
                                  addmodal={this.state.addmodal} 
                                  toggleAddModal={this.toggleAddModal} 
                                />

      return (
        <Dropzone
          disableClick
          disabled={!this.props.dropzone}
          style={{position: "relative"}}
          accept={accept}
          onDrop={this.onDrop.bind(this)}
          onDragEnter={this.onDragEnter.bind(this)}
          onDragLeave={this.onDragLeave.bind(this)}
        >
          { dropzoneActive && <div style={overlayStyle}>Drop files...</div> }
          <Table refresh={this.props.refresh} responsive={true} hover={true} className="s-grid-table-body">
                                <tbody>
                                    {this.props.rows}
                                </tbody>
                            </Table>
                            {addDocumentModalPopup} 
        </Dropzone>
      );
    }
  }
  
  //<DropZoneTable />

  export default DropZoneTable;